//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {Toast } from 'mint-ui';

  import {BASIC} from "@/config/constant"
  import promise from '@/axios/promise'
  import {formatTime} from "@/utils/common"
  export default {
    name: "signIndex",
    data() {
      return {
        scopeList:[],
        map:null,
        disabled:false,
        data:{
          signTime: '2018-12-18',
          currTime: '19:00',
          signBtn:true,
          signPlace:"",
          signAddr:'',
          createTime:null,
          signCityCode:'',
          signCity:'',
          signLongitude:'',
          signDimension:'',
          inSignScope:'是'
        }
      }
    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      toSignRecord(){
        this.$router.push({path:'/app/workRep/signRecord'});
      },
      sign(){
        //判断是否有坐标
        var signLongitude=this.data.signLongitude;
        var signDimension=this.data.signDimension;
        if(signLongitude==null || signLongitude=='' || signDimension==null || signDimension==''){
             Toast({  message: '定位失败，请检查网络和定位授权!', duration: 1500,position: 'middle', className:"warning" });
             return ;
        }
        this.disabled=true;
        promise({
          url:BASIC+'/sign/save',
          method:'post',
          params:this.data
        }).then(res=>{
            if(res.code==0){
                this.data.signBtn=false;
            }else{
               this.disabled=false;
            }
        });
      },
      getSignScope(){
        promise({
          url:BASIC+'/sign/signPlace/enabled',
          method:'get',
          params:{}
        }).then(res=>{
            if(res.code==0){
                 this.scopeList=res.data;
            }
        });
      },
      checkInScope(){//查看是否在范围内
          //获取所有的打卡范围
          var inSignScope='否';
          var map=this.map;
          var pointA = new BMap.Point(this.data.signLongitude,this.data.signDimension);  // 创建点坐标A
          this.scopeList.forEach(element => {
            var pointB = new BMap.Point(element.longitude,element.dimension); 
            var dist=map.getDistance(pointA,pointB).toFixed(2);
            var scope=parseFloat(element.scope);
            if(dist<=scope){
              inSignScope='是';
            }
          });
          this.data.inSignScope=inSignScope;
      },
     async getSignByCurrDate(){
        var self=this;
        var date=new Date();
        var signDate=formatTime(date, 'yyyy-MM-dd');
        self.data.signTime=signDate;
        self.data.currTime=formatTime(date, 'hh:mm');
        return  await promise({
            url:BASIC+'/sign/signDate',
            method:'get',
            params:{signDate:formatTime(date, 'yyyy-MM-dd')}
          }).then(res=>{
              if(res.code==0 ){
                var data=res.data;
                if(data!=null){
                  var signDate=formatTime(data.signTime, 'yyyy-MM-dd');
                  self.data.signTime=signDate;
                  self.data.currTime=formatTime(data.createTime, 'hh:mm');
                  self.data.signBtn=false;
                  self.data.signLongitude=data.signLongitude;
                  self.data.signDimension=data.signDimension;
                  self.data.signAddr=data.signAddr;
                  self.data.signPlace=data.signPlace;
                  self.data.inSignScope=data.inSignScope;
                }
              }
          });
        },
        theLocation( map,longitude,latitude){
          if(longitude!= "" && latitude!= ""){
            map.clearOverlays(); 
            var new_point = new BMap.Point(longitude,latitude);
            var marker = new BMap.Marker(new_point);  // 创建标注
            map.addOverlay(marker);              // 将标注添加到地图中
            map.panTo(new_point);      
          }
	      },
        // 定位处理
        mapLocation(){
          var self=this;
          // 百度地图API功能
          var map = new BMap.Map("allmap");
          this.map=map;
          var signLongitude=this.data.signLongitude;
          var signDimension=this.data.signDimension;
          if(this.data.signBtn){
            signLongitude=116.331398;
            signDimension=39.897445;
          }else{
              var point = new BMap.Point(signLongitude, signDimension);
              this.theLocation(map,signLongitude,signDimension);
              map.centerAndZoom(point, 17);
              var myIcon=new BMap.Icon("http://api0.map.bdimg.com/images/marker_red_sprite.png",new BMap.Size(30,25));
              return;
          }

          var point = new BMap.Point(signLongitude, signDimension);
          map.centerAndZoom(point, 17);
          var myIcon=new BMap.Icon("http://api0.map.bdimg.com/images/marker_red_sprite.png",new BMap.Size(30,25));
          // 浏览器定位
          var geolocation = new BMap.Geolocation({maximumAge:10});
          
          geolocation.getCurrentPosition(function (r) {
            if (this.getStatus() == BMAP_STATUS_SUCCESS) {
              var mk = new BMap.Marker(r.point);
              map.addOverlay(mk);
              map.panTo(r.point,true);
              var address = r.address;
              var street_number=address.street_number;
              self.data.signCity=address.city;
              self.data.signCityCode=address.city_code;
              if(street_number!=null && street_number!='' && !isNaN(street_number)){
                self.data.signPlace=address.street +address.street_number + '号';
                self.data.signAddr=address.province + address.city + address.street + address.street_number + '号';
              }else{
                self.data.signPlace=address.street; 
                self.data.signAddr=address.province + address.city + address.street;
              }
              self.data.signLongitude=r.point.lng;
              self.data.signDimension=r.point.lat;
              self.checkInScope();
              //
            } else {
              //  Toast({  message: '定位失败，请检查网络和定位授权!', duration: 1500,position: 'middle', className:"warning" });
              // alert('failed' + this.getStatus());
            }
          }, {
            enableHighAccuracy: true
          });
        }
      },
      filters:{
        formatDate(time) {
          var date = new Date(time);
          return formatTime(date, 'yyyy-MM-dd');
        }
      },
      created(){
        this.getSignScope();
      },
     async mounted() {
        await this.getSignByCurrDate();
        this.mapLocation();
        /*await this.getSignByCurrDate();
        var self=this;
        // 百度地图API功能
        var map = new BMap.Map("allmap");
        this.map=map;
        var signLongitude=this.data.signLongitude;
        var signDimension=this.data.signDimension;
        if(this.data.signBtn){
          signLongitude=116.331398;
          signDimension=39.897445;
        }else{
            var point = new BMap.Point(signLongitude, signDimension);
            this.theLocation(map,signLongitude,signDimension);
            map.centerAndZoom(point, 17);
            var myIcon=new BMap.Icon("http://api0.map.bdimg.com/images/marker_red_sprite.png",new BMap.Size(30,25));
            return;
        }

        var point = new BMap.Point(signLongitude, signDimension);
        map.centerAndZoom(point, 17);
        var myIcon=new BMap.Icon("http://api0.map.bdimg.com/images/marker_red_sprite.png",new BMap.Size(30,25));
        // 浏览器定位
        var geolocation = new BMap.Geolocation();
        geolocation.getCurrentPosition(function (r) {
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            var mk = new BMap.Marker(r.point);
            map.addOverlay(mk);
            map.panTo(r.point,true);
            var address = r.address;
            var street_number=address.street_number;
            self.data.signCity=address.city;
            self.data.signCityCode=address.city_code;
            if(street_number!=null && street_number!='' && !isNaN(street_number)){
              self.data.signPlace=address.street +address.street_number + '号';
              self.data.signAddr=address.province + address.city + address.street + address.street_number + '号';
            }else{
              self.data.signPlace=address.street; 
              self.data.signAddr=address.province + address.city + address.street;
            }
            self.data.signLongitude=r.point.lng;
            self.data.signDimension=r.point.lat;
            self.checkInScope();
            //
          } else {
            //  Toast({  message: '定位失败，请检查网络和定位授权!', duration: 1500,position: 'middle', className:"warning" });
            // alert('failed' + this.getStatus());
          }
        }, {
          enableHighAccuracy: true
        });*/

    //     var map = new AMap.Map('allmap', {
    //         resizeEnable: true
    //     });
    //     AMap.plugin('AMap.Geolocation', function() {
    //         var geolocation = new AMap.Geolocation({
    //             enableHighAccuracy: true,//是否使用高精度定位，默认:true
    //             timeout: 10000,          //超过10秒后停止定位，默认：5s
    //             buttonPosition:'RB',    //定位按钮的停靠位置
    //             buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
    //             zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点

    //         });
    //         map.addControl(geolocation);
    //         geolocation.getCurrentPosition(function(status,result){
    //           console.log(result);
    //           var p=result;
    //             if(status=='complete'){
    //               self.data.signPlace=p.addressComponent.street+p.addressComponent.streetNumber; 
    //               self.data.signAddr=p.formattedAddress;
    //               self.data.signCity=p.addressComponent.city;
    //               self.data.signCityCode=p.addressComponent.city_code;
    //               //获得当前位置的坐标
    //               var lng = p.position.R //经度
    //               var lat = p.position.Q

    //               var marker = new AMap.Marker({
    //                   position: new AMap.LngLat(lng, lat),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
    //               });
    //               map.add(marker);
    //             }else{
    //                 onError(result)
    //             }
    //         });
    //     });

    //         //解析定位结果
    // function onComplete(p) {

    // }
    // //解析定位错误信息
    // function onError(data) {
    //   alert(2);
    // }
//    var point = new BMap.Point(signLongitude, signDimension);
//      map.centerAndZoom(point, 17);
//      var myIcon=new BMap.Icon("http://api0.map.bdimg.com/images/marker_red_sprite.png",new BMap.Size(30,25));
//      var geolocation = new BMap.Geolocation();
//      geolocation.getCurrentPosition(function (r) {
//        console.log(JSON.stringify(r));
//        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
//          var mk = new BMap.Marker(r.point);
//          map.addOverlay(mk);
//          map.panTo(r.point);
//          var address = r.address;
//          var street_number=address.street_number;
//          self.data.signCity=address.city;
//          self.data.signCityCode=address.city_code;
//          if(street_number!=null && street_number!='' && !isNaN(street_number)){
//            self.data.signPlace=address.street +address.street_number + '号';
//            self.data.signAddr=address.province + address.city + address.street + address.street_number + '号';
//          }else{
//            self.data.signPlace=address.street; 
//            self.data.signAddr=address.province + address.city + address.street;
//          }
//          self.data.signLongitude=r.point.lng;
//          self.data.signDimension=r.point.lat;
//          self.checkInScope();
//          //
//        } else {
//                      //  Toast({  message: '定位失败，请检查网络和定位授权!', duration: 1500,position: 'middle', className:"warning" });
//
//          // alert('failed' + this.getStatus());
//        }
//      }, {
//        enableHighAccuracy: true
//      })


    // var u = navigator.userAgent;
    // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    // if(isiOS){
      	///************************************************************///
    // }else if(isAndroid){
      	//   var options={
        //        enableHighAccuracy:true,
        //        maximumAge:1000,
        //        timeout:5000
        //    }
        //    plus.geolocation.getCurrentPosition(function(p){
        //        console.log("浏览器定位"+JSON.stringify(p));
        //        var address = p.address;
        //        self.data.signPlace=address.poiName; 
        //        self.data.signCity=address.city;
        //        self.data.signCityCode=address.city_code;
        //        var streetNum= address.streetNum;
        //        if(streetNum!=null && streetNum!='' && !isNaN(streetNum)){
        //           self.data.signAddr=address.province+address.city+address.district+address.street+streetNum+'号';
        //        }else{
        //           self.data.signAddr=address.province+address.city+address.district+address.street+streetNum;
        //        }
        //        console.log( self.data.signAddr);
        //        //获得当前位置的坐标
        //        var lng = p.coords.longitude //经度
        //        var lat = p.coords.latitude
        //        //把原始的坐标转换为百度坐标
        //        var ggPoint = new BMap.Point(lng,lat);
        //        var convertor = new BMap.Convertor();
        //        var pointArr = [];
        //        pointArr.push(ggPoint);
        //        convertor.translate(pointArr, 3, 5, function (data){
        //          if(data.status === 0) {
        //              var point = new BMap.Point(data.points[0].lng, data.points[0].lat);
        //              map.centerAndZoom(point, 17);
        //              self.data.signLongitude=data.points[0].lng;
        //              self.data.signDimension=data.points[0].lat;
        //              var mk = new BMap.Marker(point);
        //              map.addOverlay(mk);
        //              map.panTo(point);
        //              self.checkInScope();
        //          }
        //        })
        //      }, function(e){
        //  },options);     
   // }
      //  var options={
      //       enableHighAccuracy:true,
      //       maximumAge:1000,
      //       timeout:5000
      //   }
      //   plus.geolocation.getCurrentPosition(function(p){
      //       console.log("浏览器定位"+JSON.stringify(p));
      //       var address = p.address;
      //       self.data.signPlace=address.poiName; 
      //       self.data.signAddr=address.province+address.city+address.district+address.street+address.streetNum;
      //       console.log( self.data.signAddr);
      //       //获得当前位置的坐标
      //       var lng = p.coords.longitude //经度
      //       var lat = p.coords.latitude
      //       //把原始的坐标转换为百度坐标
      //       var ggPoint = new BMap.Point(lng,lat);
      //       var convertor = new BMap.Convertor();
      //       var pointArr = [];
      //       pointArr.push(ggPoint);
      //       convertor.translate(pointArr, 3, 5, function (data){
      //         if(data.status === 0) {
      //             var point = new BMap.Point(data.points[0].lng, data.points[0].lat);
      //             map.centerAndZoom(point, 17);
      //             self.data.signLongitude=data.points[0].lng;
      //             self.data.signDimension=data.points[0].lat;
      //             var mk = new BMap.Marker(point);
      //             map.addOverlay(mk);
      //             map.panTo(point);
      //             self.checkInScope();
      //         }
      //       })
      //     }, function(e){
      // },options);     
      }
  }



// WEBPACK FOOTER //
// ./src/view/sign/signIndex.vue